export default __webpack_public_path__ + "static/media/delicious.ae1a9913.svg";